import { useState, useEffect, useRef } from "react";
import GTM from "@utils/GTM";

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}


const AdvertisementsList = ({ fields }) => {
  if (fields.advertisements.length === 0) {
    return <></>;
  }

  const [idx, setIdx] = useState(0);
  const lastIdx = fields.advertisements.length - 1;
  const intervalMs = fields.secondsPerAdvertisement * 1000;
  const ad = fields.advertisements[idx].fields;

  const nextAd = () => {
    const newIdx = idx === lastIdx ? 0 : idx + 1;
    setIdx(newIdx);
  }

  useInterval(nextAd, intervalMs);

  return (
    <>
      <div className="contentful_advertisement">
        <span style={{ fontSize: "14px", fontWeight: "bold" }}>Advertisement</span>
        <a href={ad.url} target="_blank"
          onClick={() => GTM.adClick({ adName: ad.internalName })} style={{ height: "150px", display: "flex", justifyContent: "center", alignItem: "center", backgroundColor: "rgba(0,0,0, 0.1)" }}>
          <img src={"https://" + ad.image.fields.file.url} style={{ width: "100%", objectFit: "contain" }} />
        </a>
      </div>
    </>
  );
}


export default AdvertisementsList;
